<template>
    <div class="registration-personal">
        <div class="registration-personal__credentials">
            <PhoneInput
                ref="phoneInputRef"
                class="registration-personal__phone"
                v-model="authenticationData.userName"
                name="phone"
                title="Telefonní číslo"
                :show-tooltip="true"
                placeholder="Zadejte své telefonní číslo"
                v-model:error-message="authenticationErrors.phoneErrorMessage"
                @input-error-detected="dataLayerRegistrationError"
            />

            <NewPasswordInput
                class="registration-personal__password"
                ref="newPasswordInputRef"
                v-model="authenticationData.password"
                name="password"
                v-model:error-message="authenticationErrors.passwordErrorMessage"
                @input-error-detected="dataLayerRegistrationError"
            />
        </div>
        <div id="consents" class="registration-personal__consents">
            <CheckboxInput
                class="registration-personal__consent"
                ref="checkboxRef"
                v-for="consent in authenticationData.consents"
                :key="`consent-${consent.id}`"
                :name="consent.id"
                v-model="consent.enabled"
                :description="consent.description"
                :mandatory="consent.mandatory"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { ConsentDto } from "@/account/models/registration/consent-dto";
import useRegistrationConsents from "@/account/composables/use-registration-consents";

import NewPasswordInput from "@/account/components/inputs/new-password-input.vue";
import PhoneInput from "@/account/components/inputs/phone-input.vue";
import CheckboxInput from "@/account/components/inputs/checkbox-input.vue";
import { authenticationErrors, authenticationData } from "@/account/composables/use-authentication-data";
import { dataLayerRegistrationError } from "@/data-layer/services/actions";

const { getDisplayedConsets } = useRegistrationConsents();

const phoneInputRef = ref(null);
const newPasswordInputRef = ref(null);
const checkboxRef = ref([]);

getDisplayedConsets().then((data: ConsentDto[]) => {
    authenticationData.consents = data;
});

const checkIfIsValid = () => {
    const consentsAreValid = checkboxRef.value.every((checkboxValidation) => checkboxValidation.checkIfIsValid());
    const phoneIsValid = phoneInputRef.value.checkIfIsValid();
    const newPasswordIsValid = newPasswordInputRef.value.checkIfIsValid();

    return consentsAreValid && phoneIsValid && newPasswordIsValid;
};

defineExpose({
    checkIfIsValid,
});
</script>
